export default __webpack_public_path__ + "static/CheesyGorditaCrunchesWithQuesoAndSalsa-597f77bd47838ebab199f64ed092e5b4.jpeg";